<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t("registration.registrations") }}</h2>
    </div>
    <el-card
      v-if="checkRole(['Admin'])"
      class="box-card filter-card just-for-admin"
    >
      <div slot="header" class="clearfix">
        <span>{{ $t("general.filter") }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="initSearch"
        >{{ $t("general.init") }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio
          v-model="activeList"
          label="actives"
          border
          @change="getSubRegistrationsList('indexactive')"
        >{{ $t("general.F_actives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="desactives"
          border
          @change="getSubRegistrationsList('indexdesactive')"
        >{{ $t("general.F_desactives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="disponibles"
          border
          @change="handleFilterRegistrations"
        >{{ $t("general.disponibles") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="corbeille"
          class="danger-radio"
          border
          @change="getSubRegistrationsList('indexinvisible')"
        >{{ $t("general.corbeille") }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          :placeholder="$t('general.keyword')"
          class="wd-200 mr-15 filter-item"
          @keyup.enter.native="handleFilterRegistrations"
        />
        <!-- <el-select
          v-model="query.specie_id"
          class="filter-item"
          filterable
          clearable
          :placeholder="$t('specie.specie')"
          @change="handleFilterRegistrations"
        >
          <el-option
            v-for="(specie, index) in species"
            :key="index"
            :label="specie.name | uppercaseFirst"
            :value="specie.id"
          />
        </el-select> -->
        <el-button
          v-waves
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilterRegistrations"
        >
          {{ $t("general.search") }}
        </el-button>
        <el-button
          v-waves
          :loading="downloading"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
          @click="handleDownload"
        >
          {{ $t("general.export") }}
        </el-button>
        <!-- <el-button
          v-if="checkPermission(['create registration'])"
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateRegistration"
        >
          {{ $t("general.add") }}
        </el-button> -->
      </div>
      <el-table
        v-loading="loading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column align="center" :label="$t('registration.ref')">
          <template slot-scope="scope">
            <span>{{ scope.row.ref }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('village.village')">
          <template slot-scope="scope">
            <span>{{ scope.row.village.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('registration.maleNumber')" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.male_number }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('registration.femaleNumber')" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.female_number }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('registration.status')" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.status }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('disease.diseases')">
          <template slot-scope="scope">
            <ul>
              <li v-for="disease in scope.row.frequent_diseases" :key="disease.id">
                {{ disease.disease.name }} ({{ disease.sick_animals_number }})
              </li>
            </ul>
          </template>
        </el-table-column>

        <el-table-column v-if="activeList!='corbeille' && checkPermission(['activate registration'])" align="center" :label="$t('general.status')" width="80">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setRegistrationStatus(scope.row.id,'active')"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-if="checkPermission(['edit registration', 'delete registration'])"
          align="center"
          :label="$t('general.actions')"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="checkPermission(['edit registration'])"
              type="primary"
              size="small"
              icon="el-icon-edit"
              style="margin-right: 10px"
              @click="handleEditRegistration(scope.row.id)"
            />
            <el-button
              v-if="checkPermission(['delete registration'])"
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="
                handleDeleteRegistration(
                  scope.row.id,
                  scope.row.is_visible,
                  scope.row.ref
                )
              "
            />
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="query.page"
        :limit.sync="query.limit"
        @pagination="getRegistrationsList"
      />

      <!-- ======= BREED FORM ======= -->
      <el-dialog
        :title="$t('general.details') + ' - ' + currentRegistration.ref"
        :visible.sync="dialogCreateRegistration"
        :before-close="handleCloseRegistrationCreateDraw"
        width="50%"
      >
        <div class="content-inputs">
          <el-form label-position="left" label-width="120px">
            <el-form-item :label="$t('registration.ref')+':'">
              <span>{{ currentRegistration.ref }}</span>
            </el-form-item>
            <el-form-item :label="$t('village.village')+':'">
              <span>{{ currentRegistration.village?.name }}</span>
            </el-form-item>
            <el-form-item :label="$t('registration.maleNumber')+':'">
              <span>{{ currentRegistration.male_number }}</span>
            </el-form-item>
            <el-form-item :label="$t('registration.femaleNumber')+':'">
              <span>{{ currentRegistration.female_number }}</span>
            </el-form-item>
            <el-form-item :label="$t('registration.status')+':'">
              <span>{{ currentRegistration.status }}</span>
            </el-form-item>
            <el-form-item :label="$t('registration.coordinates')+':'">
              <span>{{ currentRegistration.coordinates }}</span>
            </el-form-item>
            <el-form-item :label="$t('disease.diseases')+':'">
              <ul>
                <li v-for="disease in currentRegistration.frequent_diseases" :key="disease.id">
                  {{ disease.disease.name }} ({{ disease.sick_animals_number }})
                </li>
              </ul>
            </el-form-item>
            <el-form-item :label="$t('breed.breeds')+':'">
              <ul>
                <li v-for="breed in currentRegistration.breeds" :key="breed.id">
                  {{ breed.name }} - {{ breed.description }}
                </li>
              </ul>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align: right">
            <el-button plain type="danger" @click="dialogCreateRegistration = false">
              {{ $t("general.close") }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- ======= END BREED FORM ======= -->
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const registrationResource = new Resource('registrations');
const specieResource = new Resource('species');
export default {
  name: 'RegistrationsList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      species: [],
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      registrationCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentRegistration: {},
      dialogCreateRegistration: false,
      currentRegistrationId: 0,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('registration.NameRequired'),
            trigger: 'blur',
          },
        ],
        specie_id: [
          {
            required: true,
            message: this.$t('specie.specieRequired'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getSpeciesList();
    this.resetNewRegistration();
    this.getRegistrationsList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array) {
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseRegistrationCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    cancelRegistrationForm() {
      this.$refs.RegistrationCreationDrawer.closeDrawer();
    },
    initSearch() {
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterRegistrations();
    },
    async getRegistrationsList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await registrationResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubRegistrationsList(subUrl) {
      this.loading = true;
      const { data } = await registrationResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterRegistrations() {
      this.query.page = 1;
      this.getRegistrationsList();
    },
    handleCreateRegistration() {
      this.editing = false;
      this.resetNewRegistration();
      this.dialogCreateRegistration = true;
      this.$nextTick(() => {
        this.$refs['registrationForm'].clearValidate();
      });
    },
    handleEditRegistration(id) {
      this.editing = true;
      this.resetNewRegistration();
      this.currentRegistration = this.list.find((abonne) => abonne.id === id);
      this.dialogCreateRegistration = true;
      /* this.$nextTick(() => {
        this.$refs['registrationForm'].clearValidate();
      }); */
    },
    async setRegistrationStatus(id, type) {
      const data = await registrationResource.get('toogle_' + type + '/' + id);
      if (data.success) {
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteRegistration(id, visible, name) {
      this.$confirm(
        this.$t('registration.deleteWarn') +
          ' ' +
          name +
          '. ' +
          this.$t('general.deleteContinue'),
        'Warning',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: this.$t('general.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          if (
            !visible &&
            (checkRole(['Admin']) || checkPermission(['delete registration']))
          ) {
            this.$swal({
              title: this.$t('general.SureQuestion'),
              text: this.$t('general.irrversibleMessage'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.$t('general.ouiSupprimer'),
            }).then((result) => {
              if (result.isConfirmed) {
                registrationResource
                  .destroy(id)
                  .then((response) => {
                    this.$message({
                      type: 'success',
                      message: this.$t('registration.suppressionEffectue'),
                    });
                    this.initSearch();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            });
          } else {
            this.setRegistrationStatus(id, 'visible');
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general.suppressionAnnule'),
          });
        });
    },
    createRegistration() {
      this.$refs['registrationForm'].validate((valid) => {
        if (valid) {
          this.registrationCreating = true;
          registrationResource
            .store(this.currentRegistration)
            .then(async(response) => {
              this.$message({
                message:
                  this.$t('registration.NewRegistration') +
                  ' ' +
                  this.currentRegistration.name +
                  ' ' +
                  this.$t('registration.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentRegistrationId = response.data.id;
              this.resetNewRegistration();
              this.dialogCreateRegistration = false;
              this.handleFilterRegistrations();
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.registrationCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateRegistration() {
      this.$refs['registrationForm'].validate((valid) => {
        if (valid) {
          this.registrationCreating = true;
          registrationResource
            .update(this.currentRegistration.id, this.currentRegistration)
            .then((response) => {
              this.resetNewRegistration();
              this.handleFilterRegistrations();
              this.$message({
                message: this.$t('registration.isupdatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.dialogCreateRegistration = false;
              this.editing = false;
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.registrationCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewRegistration() {
      this.currentRegistration = {
        name: '',
      };
    },
    async getSpeciesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await specieResource.list(this.query);
      this.species = data;
      this.species.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'ID',
          this.$t('registration.name'),
          this.$t('specie.specie'),
        ];
        const filterVal = ['id', 'name', 'specie_id'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            'Registrations list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
  width: 70% !important;
  float: none !important;
  text-align: left !important;
  padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
